import { PDFViewer } from "@react-pdf/renderer";
import { Button, Col, Row } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
// import { PaymentVoucherPdf } from "./PVPDF";
import { useParams, useNavigate } from "react-router-dom";
import { apiURL, fetchApi, postApi } from "../../../redux/api";
import { Routes } from "../../../routes";
import SupportingDocumentsPv from "./SupportingDocuments";
import NewSupportingDocumentsPv from "./NewSupportducument";
import { PaymentVoucherPdf } from "./PVPDFNew";
import BackButton from "../../../components/BackButton";

const AGViewPV = () => {
  const { pv_code } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [pvList, setPvList] = useState([]);
  const [taxesApplied, setTaxesApplied] = useState([]);

  useEffect(() => {
    // if (approval_no) {
    setLoading(true);
    fetchApi(`get_new_pv_by_mda?query_type=get_upload_pv&id=${pv_code}`)
      .then((data) => {
        setPvList(data.result || []);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
    // }
  }, [pv_code]);

  useEffect(() => {
    if (pvList?.length && pvList[0]?.pv_code) {
      setLoading(true);
      fetchApi(`getTaxesAppliedByPv?pv_code=${pvList[0].pv_code}`)
        .then((data) => {
          setTaxesApplied(data?.data || []);
        })
        .catch((error) => {
          console.error("Error fetching taxes applied:", error);
        })
        .finally(() => setLoading(false));
    }
  }, [pvList]);

  const handleSubmit = () => {
    if (!pvList.length) return;

    setLoading(true);
    postApi("update_status/by/pv_code", {
      status:
        pvList[0]?.status === "Inspected" ? "st_approved" : "Approved_schedule",
      pv_code: pvList[0]?.approval_no,
    })
      .then((response) => {
        console.log("Form submitted successfully:", response);
        navigate(Routes.pv.agPvCheckIndex);
      })
      .catch((error) => {
        console.error("Form submission failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // if (!approval_no) {
  //   return <p>Error: Missing PV ID</p>;
  // }

  return (
    <div>
      <BackButton />
      <Row>
        <Col md={9}>
          <h4>AG PV No.: {pvList[0]?.pv_no}</h4>
        </Col>
        <Col md={3}>
          {pvList[0]?.status === "Inspected" ||
          pvList[0]?.status === "payment_schedule" ? (
            <Button
              variant="success"
              className="mt-3"
              onClick={handleSubmit}
              disabled={loading}
            >
              {pvList[0]?.status === "Inspected"
                ? "Request for Schedule"
                : "Approved Schedule"}
              {/* {loading ? "Processing..." : "Approve PV"} */}
            </Button>
          ) : null}
        </Col>
      </Row>

      <Row>
        <Col md={8}>
          {pvList?.length ? (
            <PDFViewer
              style={{
                width: "100%",
                height: 1000,
              }}
            >
              <PaymentVoucherPdf form={pvList} taxesApplied={taxesApplied} />
            </PDFViewer>
          ) : (
            <p>Loading PV PDF...</p>
          )}
        </Col>
        <Col md={3}>
          {pvList?.length ? (
            <NewSupportingDocumentsPv pvInfo={pvList} />
          ) : (
            <p>Loading Supporting Documents...</p>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AGViewPV;
